// extracted by mini-css-extract-plugin
export default {"Pattern":"styles_Pattern__GFuaR","FileLink":"styles_FileLink__AX9iY"};